export default __webpack_public_path__ + "static/media/cape.1157b408.jpg";